// extracted by css-extract-rspack-plugin
export default {"item":"_224e78e0"};